const UK_ENGLISH_COUNTRIES = ['AU', 'GB', 'IE', 'NZ', 'JM', 'IN'];

export const spell = (key: string, country?: string): string => {
  switch (key) {
    case 'color':
    case 'Color': {
      const useColour = country && UK_ENGLISH_COUNTRIES.includes(country.toUpperCase());
      return useColour ? (key === 'Color' ? 'Colour' : 'colour') : key;
    }
    default:
      return key;
  }
};
